// extracted by mini-css-extract-plugin
export default {"container":"RemoveButton_container","deleteIcon":"RemoveButton_deleteIcon","icon":"RemoveButton_icon","hideRemoveButton":"RemoveButton_hideRemoveButton"};